export default __webpack_public_path__ + "static/media/eye.55bb6b14.svg";